export default __webpack_public_path__ + "static/media/contributeChooseCampaign.4ff3bc7b.png";